/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrategyPriorityRatingEnum } from './strategyPriorityRatingEnum';


/**
 * Calculated strategy rating
 */
import { ValidateUtils } from 'app/shared/utils';

export class StrategyRating { 
    strategyPriorityRating?: StrategyPriorityRatingEnum;

    constructor(item?: Partial<StrategyRating>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            strategyPriorityRating: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.strategyPriorityRating : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: StrategyRating.isValid,
        };
    }

    static isValid(obj: StrategyRating): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = StrategyRating.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.strategyPriorityRating.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

